export const isBlankOrNull = value => {
  return value === null || value === undefined || String(value).trim() === "";
};
